<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :filterSelects="filterSelects"
      :pageMode="true"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/legal_inquiry";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "user_payload",
      "factory",
      "contact_person",
      "contact_for",
      "status",
      "assignee",
      "updated_at",
      "created_at",
    ],
    filterSelects: [
      {
        label: "篩選工廠",
        type: "belongsTo",
        textKey: "name",
        modelName: "factory",
        placeholder: "篩選工廠",
        getText(item) {
          return this.$_CMS_getFactoryName(item)
        },
      },
      {
        label: "篩選指派人員",
        type: "belongsTo",
        textKey: "name",
        modelName: "admin",
        paramName: "assignee",
        placeholder: "篩選指派人員",
      },
    ],
  }),
  computed: {},
};
</script>